module.exports = __webpack_public_path__ + "static/assets/c8d1f180a912909db93424c6073152db.png";